import React, { Component } from "react";
import { connect } from "react-redux";
import { Button, Modal, ModalHeader, ModalBody } from "reactstrap";
import { Link } from "react-router-dom";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import style from "./Users.module.css";
import { fetchUsersList, deleteUser } from "../../../redux";
import moment from "moment";
import ttmLoader from "../../../assets/images/ttm-loader.gif";
import { checkIfPermitted, Permissions } from "../../../services/RolePermissionService";

function dateFormatter(cell) {
  if (!cell) {
    return "";
  }
  return `${
    moment(cell).format("YYYY-MM-DD")
      ? moment(cell).format("YYYY-MM-DD")
      : moment(cell).format("YYYY-MM-DD")
  }`;
}

export class Users extends Component {
  constructor(props) {
    super(props);

    this.state = {
      searchKey: "",
      page: 1,
      sortName: undefined,
      sortOrder: undefined,
      sortBy: "",
      usersList: [],
      isDeleteModalOpen: "",
      user_id:""
    };
  }
  // Adding actions edit and delete icons
  actionsFormatter(cell, row) {
    return (
      <div>
        <Link title="Edit User" to={"/app/editsystemuser/"+ row.user_id}>
          <i class="fa fa-pencil-square-o mr-3 relatedpartylist-edit-icon"></i>
        </Link>
        {checkIfPermitted(Permissions.DELETE_SYSTEM_USERS)&&(
        <Link title="Delete User" class="action-icons relatedpartylist-add-icon"
        onClick={() => this.toggleDeleteModal(row)}>
          <i class="fa fa-trash"></i>
        </Link>
        )}
      </div>
    );
  }

  componentDidMount = async() => {
    document.title = 'Users - TechToMedix';
   await this.props.fetchUsersList(
      this.state.searchKey,
      this.state.sortBy,
      this.state.page
    );
    if(this.props.usersListData && 
      this.props.usersListData.usersList && 
      this.props.usersListData.usersList && 
      this.props.usersListData.usersList.userList) {
        this.setState({
          usersList: this.props.usersListData.usersList.userList
        })
    }

    setTimeout(() => {
      if (this.props.usersListData.usersList.total === 0) {
        this.setState({
          isDataFetched: true,
        });
      } else {
        this.setState({
          isDataFetched: false,
        });
      }
    }, 1000);
  }

  callUsersListAPI = async() => {
    this.setState({
      usersList: [],
    });
    await this.props.fetchUsersList(
      this.state.searchKey,
      this.state.sortBy,
      this.state.page
    );
    if(!this.props.usersListData.loading){
      this.setState({
        usersList: this.props.usersListData.usersList.userList
      })
      setTimeout(() => {
          this.setState({
            isDataFetched: true,
          });
      }, 1000);
    }
  }

  
/**
 * This method will be called when the sorting is changed in the table.
 */
onSortChange = (sortName, sortOrder) => {
  let sortBy;
  if (sortOrder == "desc") {
    sortBy = "-" + sortName;
  } else {
    sortBy = sortName;
  }
  this.setState({
    sortName,
    sortOrder,
    sortBy,
    page: 1,
    isDataFetched: false,
  },()=>{
    this.callUsersListAPI();
  });
};

/**
 * This method is called when page changes through pagination.
 */
onPageChange = (page, sizePerPage) => {
  this.setState({ page, isDataFetched: false },()=>{
    this.callUsersListAPI();
  });
};

onSearchChange = (event) => {
  this.setState({ 
    searchKey: event.target.value, 
    page: 1, 
    isDataFetched: false 
  },()=>{
    this.callUsersListAPI();
  });
};


  // toggle modal poup for delete appointment from list
  toggleDeleteModal = (val) => {
    this.setState((prevState) => ({
      user_id: val.user_id,
      errorMessage: "",
      isDeleteModalOpen: !prevState.isDeleteModalOpen,
    }));
  };

  onDeleteUser = async() => {

    await this.props.deleteUser(this.state.user_id);

    if (!this.props.deleteUserData.isError) {
      this.setState({
        successMessage: this.props.deleteUserData.deleteUser.message,
      });
      setTimeout(() => {
        this.setState((prevState) => ({
          successMessage: "",
          isDeleteModalOpen: !prevState.isDeleteModalOpen,
          isDataFetched: false
        }));
        this.callUsersListAPI();
      }, 3000);
    }else{
      this.setState({
        errorMessage:  this.props.deleteUserData.deleteUser.message,
      });

    }
  }

/**
 * This method will be called when there is not data or data is being fetched to show the loader.
 */
setLoader() {
  if (this.state.isDataFetched) {
    return <p>There is no data to display</p>;
  } else {
    return (
      <div>
        <img src={ttmLoader} alt='loader' className="loader-image" />
      </div>
    );
  }
}

  render() {
   // const usersList = this.props.usersListData.usersList;
    return (
      <div className={style.relatedPartiesListMainWarapper}>
        <div className="container">
          <div className="row">
            <div className="col-md-7">
              <h3>Users </h3>
            </div>
            <div
                className={`col-md-5 order-3 order-md-2 d-flex justify-content-start justify-content-md-end `}
              >
               <div className="form-group">
                  <input
                    type="text"
                    className={`form-control ${style.inputSearch}`}
                    id="search"
                    placeholder="Search here"
                    value={this.state.searchKey}
                    onChange={this.onSearchChange}
                  />
                </div>
              </div>
          </div>
          <div className="row">
            <div class="col-md-12 intro-text">
              <p>
                This is the users list on the system. These are the users
                created on the system through related parties
              </p>
            </div>
          </div>
          <BootstrapTable
          remote={true}
            bordered={false}
            data={this.state.usersList}
            version="4"
            search={false}
            pagination
            fetchInfo={{
              dataTotalSize: this.props.usersListData.usersList.total,
            }}
            options={{
              searchvalue: "",
              sortName: this.state.sortName,
              sortOrder: this.state.sortOrder,
              onSortChange: this.onSortChange,
              onSearchChange: this.onSearchChange,
              sizePerPage: 10,
              page: this.state.page,
              onPageChange: this.onPageChange,
              noDataText: this.setLoader(),
            }}
          >
            <TableHeaderColumn
              isKey
              dataField="name"
              dataSort={true}
              width="22%"
            >
              User Name
            </TableHeaderColumn>
            <TableHeaderColumn
              dataField="role_name"
              dataSort={true}
              width="23%"
            >
              User Role
            </TableHeaderColumn>
            <TableHeaderColumn dataField="email" dataSort={true} width="40%">
              Email
            </TableHeaderColumn>
            <TableHeaderColumn
              dataField="created_at"
              dataSort={true}
              dataFormat={dateFormatter}
              width="20%"
            >
              Creation Date
            </TableHeaderColumn>

            
            <TableHeaderColumn
              dataField="actions"
              dataAlign="center"
              dataFormat={this.actionsFormatter.bind(this)}
              width="10%"
            >
              Actions
            </TableHeaderColumn>
          </BootstrapTable>
        </div>

         {/* Open a modal for delete Appointment */}
         <Modal
          isOpen={this.state.isDeleteModalOpen}
          toggle={this.toggleDeleteModal}
          className={style.deleteReason}
          centered
        >
          <ModalHeader
            toggle={this.toggleDeleteModal}
            className={style.deleteModalHeader}
          >
            Delete User
          </ModalHeader>
          <ModalBody>
            {!this.state.errorMessage && (
              <div className={style.deleteReasonHeadingWrapper}>
                <p>
                  Please confirm whether you want to delete this user.
                </p>
              </div>
            )}
            <div className={style.deleteReasonFormWrapper}>
              <form>
                <div className={style.error}>{this.state.errorField}</div>

                {!this.state.errorMessage && !this.state.successMessage && !this.props.deleteUserData.loading  && (
                  <div className="row">
                    <div className={`col-md-12 ${style.deleteBtnWrapper}`}>
                      <button
                        type="button"
                        className="ttm-primary-btn"
                        onClick={this.onDeleteUser}
                      >
                        Delete
                      </button>
                    </div>
                  </div>
                )}
                {this.props.deleteUserData.loading &&(
                <div className="align-center">
                <img src={ttmLoader} alt='loader' className="loader-image" />
              </div>
                )}

                <div className="row">
                  <div className="col-md-12">
                    {this.state.successMessage && (
                      <p className={style.successMessage}>
                        {this.state.successMessage}
                      </p>
                    )}
                    {this.state.errorMessage && (
                      <p className={style.errorMessage}>
                        {this.state.errorMessage}
                      </p>
                    )}
                  </div>
                </div>
              </form>
            </div>
          </ModalBody>
        </Modal>
      </div>
    );
  }
}

// export default Users;
const mapStateToProps = (state) => {
  return {
    usersListData: state.usersList,
    deleteUserData: state.deleteUser,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchUsersList: (searchKey, sortBy, page) =>
      dispatch(fetchUsersList(searchKey, sortBy, page)),
      deleteUser: (userId) => dispatch(deleteUser(userId)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Users);
